import * as React from 'react'
import { createRoot } from 'react-dom/client'
import 'rxjs'

import './styles/html.css'
import App from './components/App'

const domNode = document.getElementById('root')
if (!domNode) throw new Error('Unable to initialize app. Root node not found.')
const root = createRoot(domNode)

root.render(<App />)
